import(/* webpackMode: "eager" */ "/vercel/path0/apps/ahnu/src/styles/global.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/white-site/src/app/[lang]/ClientRoot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OsanoScript"] */ "/vercel/path0/libs/react/src/components/cookie-preferences/OsanoScript/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HighPriorityImagesWarning"] */ "/vercel/path0/libs/react/src/components/errors/devtools/HighPriorityImagesWarning/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopErrorProvider"] */ "/vercel/path0/libs/react/src/components/errors/devtools/TopErrorProvider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopLevelSuspenseReporter"] */ "/vercel/path0/libs/react/src/components/errors/devtools/TopLevelSuspenseReporter/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["getHook"] */ "/vercel/path0/libs/services/src/utils/react-utils/hook-utils.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/@vercel/analytics/dist/next/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/vercel/path0/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
